export interface KeycloakInitializationOptions {
  loadUserProfile?: boolean;
  loadUserInfo: boolean;
}
